import { Permission } from './schema'

export const EducationPermissions = {
  COURSE_READ: [Permission.EducationCourseRead],
  CERTIFICATIONS_READ: [
    Permission.EducationCertificationRead,
    Permission.UserRead,
    Permission.EducationCourseRead,
  ],
}
